import React, { useCallback, useState } from "react";
import "./styles/StripesApp.css";
import LeftBox from "./Components/LeftBox";
import Board from "./Components/Board";
import Helppanel from "./Components/Helppanel";
import { PictureSet } from "./Setting_difficulty";

interface StripesProps {
  pictureSet?: PictureSet;
  difficulty?: number;
  restart?: boolean;
}

const StripesApp = (props: StripesProps) => {
  const [isOpenPanel, setisOpenPanel] = useState<boolean>(false);
  const [isRunningTime, setisRunningTime] = useState<boolean>(false);
  const [isStartGame, setisStartGame] = useState<boolean>(false);
  const [gameCompleted, setGameCompleted] = useState<boolean>(false);
    const handleResetGame = useCallback(() => {
    setisStartGame(false);
    setGameCompleted(false);
    setisRunningTime(false);
    
    // Можно добавить дополнительную логику сброса если нужно
  }, []);
  return (
    <div id="stripes-content">
      <div className="stripes-conteiner">
        <LeftBox
          setisStartGame={setisStartGame}
          isRunningTime={isRunningTime}
          isStartGame={isStartGame}
          gameCompleted={gameCompleted}
           stateRestart={props.restart} 
            onResetGame={handleResetGame} 
        />
        <Board
          setisOpenPanel={setisOpenPanel}
          setisRunningTime={setisRunningTime}
          isStartGame={isStartGame}
          gameCompleted={gameCompleted}
          setGameCompleted={setGameCompleted}
          difficulty={props.difficulty}
          pictureSet={props.pictureSet}
          onResetGame={handleResetGame} 
        />
        <Helppanel isOpenPanel={isOpenPanel} setisOpenPanel={setisOpenPanel} />
      </div>
    </div>
  );
};

export default StripesApp;
